{
    "name": "full",
    "duration": 0.8000001,
    "keyframes": {
        "/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_left/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_left/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_left/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_left/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_right/m_LocalRotation.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_right/m_LocalRotation.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_right/m_LocalRotation.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_right/m_LocalRotation.w": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "/m_LocalPosition.x": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.y": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "/m_LocalPosition.z": [
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
            0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0
        ],
        "base/eye_left/m_LocalPosition.x": [
            0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983,
            0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983,
            0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983,
            0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983, 0.329999983,
            0.329999983
        ],
        "base/eye_left/m_LocalPosition.y": [
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092
        ],
        "base/eye_left/m_LocalPosition.z": [
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527
        ],
        "base/eye_right/m_LocalPosition.x": [
            -0.330435485, -0.330435485, -0.330435485, -0.330435485, -0.330435485,
            -0.330435485, -0.330435485, -0.330435485, -0.330435485, -0.330435485,
            -0.330435485, -0.330435485, -0.330435485, -0.330435485, -0.330435485,
            -0.330435485, -0.330435485, -0.330435485, -0.330435485, -0.330435485,
            -0.330435485, -0.330435485, -0.330435485, -0.330435485, -0.330435485
        ],
        "base/eye_right/m_LocalPosition.y": [
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092, 1.00173092,
            1.00173092
        ],
        "base/eye_right/m_LocalPosition.z": [
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527, 0.5602527,
            0.5602527, 0.5602527, 0.5602527, 0.5602527
        ],
        "/m_LocalScale.x": [
            1.25, 1.25524879, 1.26453876, 1.27703929, 1.29191971, 1.30834949, 1.325498,
            1.34253466, 1.35862887, 1.37295008, 1.38466752, 1.39295077, 1.39696908,
            1.395892, 1.38888884, 1.37696874, 1.36227775, 1.34569085, 1.32808328,
            1.31032979, 1.29330552, 1.27788532, 1.26494431, 1.25535762, 1.25
        ],
        "/m_LocalScale.y": [
            1.25, 1.27460432, 1.29758346, 1.31876338, 1.33796966, 1.35502791, 1.36976385,
            1.38200331, 1.39157176, 1.39829493, 1.40199864, 1.40250838, 1.3996501,
            1.39324915, 1.3831315, 1.36989367, 1.35472679, 1.33834779, 1.32147408,
            1.30482256, 1.28911054, 1.27505517, 1.26337349, 1.25478268, 1.25
        ],
        "/m_LocalScale.z": [
            1.25, 1.25524879, 1.26453876, 1.27703929, 1.29191971, 1.30834949, 1.325498,
            1.34253466, 1.35862887, 1.37295008, 1.38466752, 1.39295077, 1.39696908,
            1.395892, 1.38888884, 1.37696874, 1.36227775, 1.34569085, 1.32808328,
            1.31032979, 1.29330552, 1.27788532, 1.26494431, 1.25535762, 1.25
        ],
        "base/eye_left/m_LocalScale.x": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_left/m_LocalScale.y": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_left/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_right/m_LocalScale.x": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_right/m_LocalScale.y": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ],
        "base/eye_right/m_LocalScale.z": [
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0,
            1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0
        ]
    },
    "wrapMode": 2,
    "guid": "7f12e1b42e0624a68b6be29799d7a3a6",
    "assetPath": "Assets/Characters/Prototype/blob@full.fbx"
}
